import { cva } from 'class-variance-authority';

export type TabsVariant = 'basic' | 'contained' | 'pills' | null | undefined;

export const variants = {
  variant: {
    basic:
      'px-m py-xxs text-content-subdued data-[state=active]:text-content-link data-[state=active]:border-b data-[state=active]:border-accent data-[state=active]:border-b-2',
    contained:
      'px-m py-xxs text-content-subdued data-[state=active]:text-content-link data-[state=active]:border-t data-[state=active]:border-accent data-[state=active]:border-t-2',
    // A segmented-control look (rounded pill background, active tab as a
    // raised white pill) rather than basic/contained's underlined-tab look
    // - e.g. for switching between a few short, icon-labeled options where
    // the underline style would look sparse.
    pills:
      'rounded-circle px-m py-xs text-content-subdued data-[state=active]:text-content-default data-[state=active]:bg-surface data-[state=active]:shadow-xs',
  },
  defaultVariants: { variant: 'basic' },
};

export const baseVariantStyles = cva(undefined, {
  variants: { ...variants },
});
